import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

/**
 * Renderiza um código de barras Code128 (padrão universal — todos os leitores
 * de código de barras reconhecem, incluindo os mais básicos e os industriais).
 *
 * Props:
 *  - value: string a ser codificada (o nº do pedido / bling_number)
 *  - height: altura em px (default 60)
 *  - fontSize: tamanho do texto abaixo (default 14)
 *  - displayValue: mostra o valor abaixo da barra (default true)
 */
export default function Barcode({ value, height = 60, fontSize = 14, displayValue = true, className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      JsBarcode(ref.current, String(value), {
        format: "CODE128",
        displayValue,
        height,
        fontSize,
        margin: 4,
        background: "#ffffff",
        lineColor: "#000000",
      });
    } catch (e) {
      // Valor inválido: JsBarcode silenciosamente falha, o svg fica vazio.
      console.warn("JsBarcode falhou para valor:", value, e?.message);
    }
  }, [value, height, fontSize, displayValue]);

  if (!value) return null;
  return <svg ref={ref} className={className} data-testid={`barcode-${value}`} />;
}
